import { render, staticRenderFns } from "./FooterFullStudio7.vue?vue&type=template&id=76153adb&scoped=true"
import script from "./FooterFullStudio7.vue?vue&type=script&lang=js"
export * from "./FooterFullStudio7.vue?vue&type=script&lang=js"
import style0 from "./FooterFullStudio7.vue?vue&type=style&index=0&id=76153adb&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76153adb",
  null
  
)

export default component.exports